export default "__VITE_ASSET__CbH_WUqH__"